import { Helmet } from "react-helmet-async";
import '../styles/equipamentos2.min.css';

import Img1 from '../assets/pilates-banner-equip-cadillac.png';
import Img2 from '../assets/banner-404-agrupado.png';
import Img3 from '../assets/pilates-image-reformer.png';

export default function Home() {

   return (
    <>
        <Helmet>
            <title>OsteoVitta Pilates - Criciúma</title>
            <link rel="canonical" href="https://www.osteovitta.com.br/equipamentos/reformer" />
            <meta name="description" content="Descubra os benefícios do Pilates na OsteoVitta em Criciúma." />
        </Helmet>

        <main>

            <section className="equipamentos-pilates">

                <div className="equip-cadillac-banner-box">

                    <div className="equip-pilates-banner-img">
                        <img className="hide--mobile" src={Img1}/>
                        <img className="hide--desk" src={Img2}/>
                    </div>


                    <div className="equip-pilates-title">
                        <h1> Equipamento <br/><span className="text-bold"> Reformer</span> </h1>
                        <img className="cadillac-img" src={Img3}/>
                    </div>

                </div>

                <div className="pilates-cadillac-title">
                    <h2>
                        O reformer desafia o seu corpo através de um carrinho deslizante, molas e cordas. Além disso a diversão
                        ser garantida
                    </h2>
                </div>

                <div className="pilates-cadillac-text">

                    <span>
                        O Reformer é talvez o mais renomado de todos os equipamentos de Pilates. Com um sofisticado sistema de
                        molas, alças e polias, mais de 100 exercícios podem ser executados neste surpreendente e versátil
                        aparelho.<br/><br/>

                        O principal está na plataforma na qual pode-se sentar, ajoelhar, apoiar ou deitar de frente ou de costas.
                        O usuário empurra ou puxa a barra de pés usando os braços, pernas, punhos e tornozelos para deslizar para
                        frente e para trás ao longo dos trilhos de uma forma controlada, enquanto a tensão das molas gentilmente
                        trabalha os músculos.<br/><br/>

                        O Pilates Reformer ajuda a estabelecer a estabilidade do tronco e o alinhamento postural enquanto se
                        trabalha os músculos periféricos em uma faixa de movimento. As molas ajustáveis permitem uma resistência
                        progressiva, o que ajuda a alongar e fortalecer os músculos. Ele ajuda na realização de um trabalho
                        efetivo, alongamento sem impacto e tonificação da musculatura, sendo então amigável para todas as
                        articulações.<br/><br/>

                        Não fique surpreso se alguns exercícios básicos do Reformer parecerem simples - um relaxante deslizamento
                        para frente e para trás no e carrinho quase sem esforço, já estará promovendo um trabalho fantástico de
                        fortalecimento e estabilização. Os efeitos vão ainda mais longe e você irá utilizar músculos que você nem
                        sabia que você tinha. A medida que você progride, o desafio físico se torna significantemente
                        maior.<br/><br/>
                    </span>

                </div>
            </section>

        </main>
    </> 
  );
}